import React, { FC, useCallback, useMemo } from 'react'
import format from 'date-fns/format'
import classNames from 'classnames'
import styles from 'styles/components/template.module.scss'
import text from 'styles/utility/text.module.scss'
import { Spacer } from 'components/Utility'
import { useDispatch, useSelector } from 'react-redux'
import { BlueButton, NavButton } from 'components/Button'
import { Description, MainHeadline } from 'components/Typography'
import { DepositHistoryCard } from 'components/Card'
import { State } from 'index'
import { getShopRef } from 'reducks/store/selectors'
import { useQueryShopPayouts } from 'hooks/revenue'
import { push } from 'connected-react-router'

const BankTransferCompleteTemplate: FC = () => {
  const dispatch = useDispatch()
  const shopRef = useSelector((state: State) => getShopRef(state))
  const payouts = useQueryShopPayouts(shopRef?.id, 1)
  const payout = payouts[0]
  const printDepositHistory = useCallback(() => {
    if (!payout) return
    dispatch(push(`/account/revenue/deposit_history/print/${payout.payoutId}`))
  }, [payout])
  return (
    <div className={styles.standard}>
      <Spacer size={28} />
      <MainHeadline headline={'入金を受け付けました'} />
      <Spacer size={28} />
      <Description description={'予めご設定いただいている銀行口座へ入金処理を行いました。'} />
      <Spacer size={20} />
      {payout && <DepositHistoryCard payout={payout} />}
      <Spacer size={12} />
      <Description description={'入金履歴明細に関するお問い合わせ先'} />
      <a
        className={classNames(text.color_blue_main)}
        href={'mailto:support@sacrisupport.zendesk.com'}
        target={'_blank'}
        rel={'noopener noreferrer'}
      >
        support@sacrisupport.zendesk.com
      </a>
      <Spacer size={28} />
      <BlueButton label={'印刷する'} onClick={printDepositHistory} size={'medium'} type={'main'} />
      <Spacer size={72} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} url={'/'} />
      <Spacer size={72} />
    </div>
  )
}

export default BankTransferCompleteTemplate
